<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Permisos del rol</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Roles</a>
        </li>
        <li class="breadcrumb-item active">Permisos</li>
      </ol>
    </div>
    <div v-if="mevengo===true" class="card">
      <div class="card-header">
        <div class="col-md-12">
          <br>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label><strong>Nombre del rol</strong></label>
                <br><label v-text="role.name"/>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="role.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </div>
            </div>
            <div class="col"/>
            <div class="col"/>
            <div class="col"/>
            <div class="col"/>
          </div>
          <br>
          <div v-if="role.name !== 'Administrador'" class="form-group">
            <div class="form-check form-check-inline">
              <input
                id="inlineRadio5"
                v-model.trim="checkboxmanual"
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                value="2"
                @change="fetchData(1, role.id, search, checkboxmanual)"
              >
              <label class="form-check-label" for="inlineRadio2">Todos</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="inlineRadio3"
                v-model="checkboxmanual"
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                value="0"
                @change="fetchData(1, role.id, search, checkboxmanual)"
              >
              <label class="form-check-label" for="inlineRadio2">No asignados</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="inlineRadio4"
                v-model.trim="checkboxmanual"
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                value="1"
                @change="fetchData(1, role.id, search, checkboxmanual)"
              >
              <label class="form-check-label" for="inlineRadio2">Asignados</label>
            </div>
          </div>

          <div v-else class="form-group">
            <label>
              <strong>
                El administrador tiene todos los permisos asignados
              </strong>
            </label>
          </div>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              <th>Nombre del permiso</th>
              <th>Módulo al que pertenece</th>
              <th>Estado</th>
              <th v-if="role.name !== 'Administrador'">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="permits in permitsArray" :key="permits.id">
              <td v-text="permits.permits.name"/>
              <td v-text="permits.permits.module"/>
              <td>
                <span v-if="permits.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td v-if="role.name !== 'Administrador'">
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group"
                  >
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Desactivar permiso'" v-if="permits.state==1" class="btn btn-danger" @click="openModal('deactivate', permits)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar permiso'" v-else class="btn btn-info" @click="openModal('activate', permits)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, checkboxmanual)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- MODALES -->
      <sweet-modal ref="activar_modal" icon="info">
        {{ tituloModalActivar }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activar_modal.close()"
        >
          No
        </button>
        <button
          v-if="tipoAccion == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="deactivatePermit()"
        >
          Si
        </button>
        <button
          v-if="tipoAccion == 4"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activatePermit()"
        >
          Si
        </button>
      </sweet-modal>
    </div>
    <div v-else class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, sameAs, minLength, between } from 'vuelidate/lib/validators'
import ladda from 'ladda'

export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      mevengo: false,
      checkboxmanual: 1,
      tituloModalActivar: '',
      permitsArray: [],
      arrayPermisos: [],
      id: 0,
      tipoAccion: 0,
      titleModal: '',
      equal: '',
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      search: '',
      role: {

      }
    }
  },
  validations: {

  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.$route.query.item, this.search, this.checkboxmanual)
    this.getRole(this.$route.query.item)
    this.selectPermits()
  },
  methods: {
    changePage (page, search, checkboxmanual) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, me.role.id, search, checkboxmanual)
    },
    async fetchData (page, id, search, checkboxmanual) {
      let me = this
      const response = await axios.get(
        `/api/admin/roles/activePermits?page=${page}&id=${id}&search=${search}&checkboxmanual=${checkboxmanual}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.permitsArray = respuesta.permits.data
          me.pagination = respuesta.pagination
          me.mevengo = true
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getRole (id) {
      let me = this
      axios.get(`/api/admin/roles/getById?id=${id}`)
        .then(function (response) {
          me.role = response.data.role[0]
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea revocar el permiso al rol?'
          this.id = data['id']
          this.tipoAccion = 3
          break
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea reactivar el permiso al rol?'
          this.id = data['id']
          this.tipoAccion = 4
          break
        }
      }
    },
    closeModal () {
      this.$v.$reset()
      this.name = ''
      this.id = 0
      this.stock = 0.0
      this.location = ''
      this.idplace = 0
      this.idrole = 0
      this.id = 0
      this.titleModal = ''
      this.tituloModalActivar = ''
      this.$refs.activar_modal.close()
      this.fetchData(this.pagination.current_page, this.role.id, this.search, this.checkboxmanual)
    },
    activatePermit () {
      let me = this
      axios.put('/api/admin/roles/activatePermit', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    deactivatePermit () {
      let me = this
      axios.put('/api/admin/roles/deactivatePermit', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    validarTecla: function (e) {
      if (e.keyCode === 13) {

      } else if (e.keyCode === 50) {
        console.log('@ was pressed')
      }
    },
    rolenull () {
      if (this.role === undefined) {
        this.$router.push({name: 'Roles'
        })
      } else {
        this.fetchData(1, this.role.id, this.search, this.checkboxmanual)
        this.idrole = this.role.id
      }
    },
    selectPermits () {
      let me = this
      var url = '/api/admin/roles/permits'
      axios.get(url).then(function (response) {
        var respuesta = response.data
        me.arrayPermisos = respuesta.permits
      })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
.imgRedondo {
  width: 150px !important;
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/persons/Permits.vue